import { render, staticRenderFns } from "./payment-request.vue?vue&type=template&id=6b6d6e5c&"
import script from "./payment-request.vue?vue&type=script&lang=js&"
export * from "./payment-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports